import { Component, Vue } from 'vue-property-decorator'
import { getDraftList, delDraftById } from '@/api/draft'
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'


@Component({})
export default class Drafts extends Vue {
  socket: any = null
  tableData = []
  loading = false
  tableHeader = []
  page = 1
  limit = 20
  total = 0
  tableHeadFilter = {
    name: ''
  }
  // tableRandom = Math.random()

  // 新增删除弹框 2021.9.27 by yongbo · di
  delDraftDialogShow = false
  delDraftId: number = null
  timer = null


  menuBtn = menuBtn

  created() {
    this.getTableData()
  }

  get userId() {
    return UserModule.userId
  }

  async getTableData() {
    this.loading = true

    const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit })
    if ('createdAt' in obj) {
      (function () {
        obj.createdAt = obj.createdAt.map((item: string) => {
          return formatDate('yyyy-MM-dd', new Date(item))
        });
        obj.createdAt = obj.createdAt.join('/')
      })()
    }
    if ('followAt' in obj) {
      (function () {
        obj.followAt = obj.followAt.map((item: string) => {
          return formatDate('yyyy-MM-dd', new Date(item))
        });
        obj.followAt = obj.followAt.join('/')
      })()
    }
    const data: any = await getDraftList(obj)
    const arr1 = data.draftList
    this.tableData = [...arr1]
    this.total = data.allNum
    // this.tableRandom = Math.random()
    this.$nextTick(() => {
      (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
    });
    this.loading = false

  }
  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }
  removePropertyOfNull(object: any) {
    const obj = JSON.parse(JSON.stringify(object))
    Object.keys(obj).forEach(item => {
      if (!obj[item] || obj[item].length === 0) delete obj[item]
    })
    return obj;
  }
  async edit(row: any) {

    if(row.types == 'customerBusiness'){
      this.openPage('/customer/addBClassifyCustomer?id=' + row.id + '&type=3')
    }
    if(row.types == 'projectMarketCooperation'){
      this.openPage('/projectList/shelfPanterProject?id=' + row.id)
    }
    if(row.types == 'financeOrder'){
      if(row.isDissertation == 1){
        this.openPage('/financialCenter/newPaperOrder?draftId=' + row.id)
      }else {
        this.openPage('/financialCenter/newOrdinaryOrder?draftId=' + row.id)
      }
    }
    if(row.types === 'financeBackMoney') {
      if(row.mainPart === '0') this.openPage('/financialCenter/newBackMoneyStudent?draftId=' + row.id)
      if(row.mainPart === '1') this.openPage('/financialCenter/newBackMoneyMechanism?draftId=' + row.id)
    }
    if(row.types === 'financeCommission') {
      this.openPage('/financialCenter/commissionEdit?draftId=' + row.id)
    }
    if(row.types === 'financeRefund') {
      this.openPage('/financialCenter/newRefund?draftId=' + row.id)
    }
    // switch (row.types) {
    //   case 'customerBusiness':
    //     this.openPage('/customer/addBClassifyCustomer?id=' + row.id + '&type=3')
    //     break;
    //   case 'projectMarketCooperation':
    //     this.openPage('/projectList/shelfPanterProject?id=' + row.id)
    //     break;
    //   case 'financeOrder':
    //     this.openPage('/financialCenter/newOrdinaryOrder?draftId=' + row.id)
    //     break;
    //   default:
    //     break;
    // }
  }

  openPage(url: string) {
    const win = window.open(window.location.origin + url)
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }

  detele(row: any) {
    this.delDraftId = row.id
    this.delDraftDialogShow = true
  }

  async delDraftDialogConfirm() {
    await delDraftById({ id: this.delDraftId })
    this.delDraftDialogShow = false
    this.$message.success('草稿删除成功')
    this.delDraftId = null
    this.getTableData()
  }

}
